// src/config.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

export const API = API_BASE_URL;

// If you use Socket.IO namespaces
export const PUBLIC_SOCKET_NS = `${API_BASE_URL}/public`;

// If you ever need a general resolver for static media coming from the backend
export const resolveBackendPath = (src, fallback = '') => {
  if (!src) return fallback;
  if (/^https?:\/\//i.test(src)) return src;   // already absolute
  const path = src.startsWith('/') ? src : `/${src}`;
  return `${API_BASE_URL}${path}`;
};
